import { takeLatest } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import {
  addAssetSaga,
  deleteAssetSaga,
  editAssetSaga,
  getAssetsSaga,
} from "./saga";

export default function* watchAsset() {
  yield takeLatest(actionTypes.GET_ASSETS, getAssetsSaga);
  yield takeLatest(actionTypes.ADD_ASSET, addAssetSaga);
  yield takeLatest(actionTypes.EDIT_ASSET, editAssetSaga);
  yield takeLatest(actionTypes.DELETE_ASSET, deleteAssetSaga);
}
